/**
 * Design-system chart palette constants.
 *
 * Hex values are sourced from client/src/theme/classy/_variables.scss.
 * These MUST be literal hex strings — Nivo renders to SVG and CSS custom
 * properties do not resolve inside SVG paint attributes.
 */

/** 8-colour base palette — design system -300 tokens (light-mode readable on white) */
export const CHART_PALETTE_8 = [
	'#fcef48',  // yellow-300
	'#c7ff4e',  // green-300
	'#62fbfc',  // aqua-300
	'#80ffa1',  // teal-300
	'#cec1f1',  // purple-300
	'#ffaa9c',  // red-300
	'#faa7b4',  // maroon-300
	'#f8c379',  // orange-300
] as const;

/** Extended 16-colour palette — -300 then -400 shades for dense charts (8+ categories) */
export const CHART_PALETTE_16 = [
	...CHART_PALETTE_8,
	'#f9e22c',  // yellow-400
	'#b1f625',  // green-400
	'#1eedf2',  // aqua-400
	'#33f566',  // teal-400
	'#af98e8',  // purple-400
	'#ff7963',  // red-400
	'#f7758d',  // maroon-400
	'#f4a043',  // orange-400
] as const;

/**
 * Full 36-colour palette — 9 hue families, ordered to maximise contrast between
 * adjacent entries. Starting at blue, every third hue is picked (step=3 over 9),
 * exhausting all families before repeating:
 *   Pass 1 (~120° apart): blue → green → red
 *   Pass 2 (~120° apart): aqua → yellow → maroon
 *   Pass 3 (~120° apart): teal → orange → purple
 * Shades within each family: 300→400→200→500 (-500 is muddier, last resort).
 */
export const CHART_PALETTE_36 = [
	'#85c7ff', '#56a0ff', '#b3dfff', '#2f79ff',  // blue    300→400→200→500
	'#c7ff4e', '#b1f625', '#e1ff95', '#92dd05',  // green   300→400→200→500
	'#ffaa9c', '#ff7963', '#ffcdc5', '#ff4f32',  // red     300→400→200→500
	'#62fbfc', '#1eedf2', '#a3fefe', '#02d1d8',  // aqua    300→400→200→500
	'#fcef48', '#f9e22c', '#fdf98b', '#e8c60a',  // yellow  300→400→200→500
	'#faa7b4', '#f7758d', '#fccfd6', '#ee4568',  // maroon  300→400→200→500
	'#80ffa1', '#33f566', '#b2ffc5', '#09de41',  // teal    300→400→200→500
	'#f8c379', '#f4a043', '#fbddad', '#f1831d',  // orange  300→400→200→500
	'#cec1f1', '#af98e8', '#e3dcf8', '#9071db',  // purple  300→400→200→500
] as const;

/** Default palette — 36 colours before any repeat */
export const CHART_PALETTE = CHART_PALETTE_36;
